<template>
  <div class='modal-container' style='width: 800px;'>
    <div class='modal-header fl mb-2'>
      <h3>Persoonsgegevens Wijzigen</h3>
    </div>

    <div class='modal-body hf'>
      <p class='mb-4'>Met onderstaand formulier wijzigt u de persoonsgegevens voor {{modalData.employee.name}}. De gegevens worden direct gewijzigd wanneer u op opslaan drukt.</p>
      <div class='hf fl mb-4'>
        <text-field v-model="initials" :errors="validations.messagesFor('initials')"
          :label="'employee.initials' | translate" style='max-width: 150px;' class='mr-4' />

        <text-field v-model="middleName" :label="'employee.last-name-prefixes' | translate" optional class='mr-4' />

        <text-field v-model="lastName" :errors="validations.messagesFor('lastName')"
          :label="'employee.last-name' | translate" />
      </div>

      <div class='fl hf mb-4'>
        <text-field optional v-model="middleNamePartner" :label="'employee.last-name-partner-prefixes' | translate" class='mr-4' />
        <text-field optional v-model="lastNamePartner" :label="'employee.last-name-partner' | translate" />
      </div>

      <div class='fl hf mb-4'>
        <gender-switch class='hf mr-4' style='width: 50%'
          :gender="gender"
          label="Geslacht"
          :onMaleSelect="() => gender = 'Male'"
          :onFemaleSelect="() => gender = 'Female'" />

        <v-menu :close-on-content-click="false" v-model="isDatePickerOpen" lazy transition="slide-y-transition"
          offset-y full-width min-width="290px" style='width: 50%;'>
          <text-field class='hf' :value="formatDate(dateOfBirth)" slot="activator" label='Geboortedatum' :errors="validations.messagesFor('dateOfBirth')">
            <v-icon slot='right'>event</v-icon>
          </text-field>
          <v-date-picker locale="nl-nl" v-model="dateOfBirth" @input="isDatePickerOpen = false" :max="new Date().toISOString()" min='1940-01-01' />
        </v-menu>
      </div>

      <div class='fl hf mb-3' v-if="modalData.isShowingExtras">
        <div style='width: 50%;' class=" input-container mr-3" >
          <text-field v-model="bsn" label='BSN' />
        </div>
        <div style='width: 50%;' class='input-container' >
          <text-field class="mr-3" v-model="email" label='E-Mail'>
            <v-icon slot="right">alternate_email</v-icon>
          </text-field>
        </div>
      </div>

      <div class='input-container' v-if="modalData.isShowingExtras">
        <div class='fl hf mb-3'>
          <text-field style='width: 68%' class='mr-3' v-model="street" label='Straat, Huisnummer en Toevoeging'/>
          <text-field style='width: 16%; margin-top: 22px;' class='mr-3' v-model="houseNumber" />
          <text-field style='width: 16%; margin-top: 22px;' v-model="houseNumberExtension" />
        </div>
        <div class='fl hf'>
          <text-field v-model="zipCode" label='Postcode' class='mr-3' />
          <text-field v-model="city" label='Stad' class='mr-3'/>
          <text-field v-model="country" label='Land' />
        </div>
      </div>

    </div>

    <div class="modal-footer" style='padding-top: 10px;'>
      <div style='float: right;'>
        <Button primary  @click="this.handleClose" class='mr-3'>{{ 'buttons.cancel' | translate }}</Button>
        <Button positive @click="this.handleSave" :disabled="!isValid || isLoading">{{ (isLoading ? 'employees.form.confirming-and-updating-personal' : 'employees.form.confirm-and-update-personal') | translate }}</button>
      </div>
      <div style='clear: both;' />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/shared/constants/modal';
import Helpers from '@/shared/helpers/functions';
import Employees from '@/resources/constants/employees';
import EmployeeSummaryPersonalEdit from '@/views/constants/employee-summary-personal-edit';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import GenderSwitch from '@aevitae/aevitaeui/1_molecules/buttons/GenderSwitch.vue';
import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';
import DatePicker from '@aevitae/aevitaeui/1_molecules/Input/DatePicker.vue';


export default {
  name: 'EmployeeSummaryPersonalEdit',
  components: {
    Button,
    GenderSwitch,
    TextField,
    DatePicker
  },
  props: {
    modalData: null
  },
  data () {
    return {
      isDatePickerOpen: false
    };
  },

  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),
    handleClose () {
      this.$store.dispatch(Modal.Actions.CLOSE);
    },
    handleSave () {
      const employerId = this.$store.getters.selectedEmployer.id;

      this.$store.dispatch(Employees.Actions.Update.START, {
        employee: this.formObject,
        employerId: employerId
      });
    },

    dispatchChange (attribute, value) {
      this.$store.dispatch(
        EmployeeSummaryPersonalEdit.Actions.Form.CHANGE, {
          attribute: attribute,
          value: value
        }
      );
    }
  },

  computed: {
    ...mapGetters({
      formObject: 'employeeSummaryPersonalFormObject',
      validations: 'employeePersonalEditValidations',
      requiredFields: 'employeePersonalEditRequiredFields',
      isLoading: 'isUpdateEmployeeLoading'
    }),

    isValid () {
      return this.validations.isValid() && this.requiredFields.isValid();
    },

    initials: {
      get () { return this.formObject.initials; },
      set (v) { this.dispatchChange('initials', v); }
    },
    lastName: {
      get () { return this.formObject.lastName; },
      set (v) { this.dispatchChange('lastName', v); }
    },
    lastNamePartner: {
      get () { return this.formObject.lastNamePartner; },
      set (v) { this.dispatchChange('lastNamePartner', v); }
    },
    middleName: {
      get () { return this.formObject.middleName; },
      set (v) { this.dispatchChange('middleName', v); }
    },
    middleNamePartner: {
      get () { return this.formObject.middleNamePartner; },
      set (v) { this.dispatchChange('middleNamePartner', v); }
    },
    gender: {
      get () { return this.formObject.gender; },
      set (v) { this.dispatchChange('gender', v); }
    },
    dateOfBirth: {
      get () { return this.formObject.dateOfBirth; },
      set (v) { this.dispatchChange('dateOfBirth', v); }
    },
    bsn: {
      get () { return this.formObject.bsn; },
      set (v) { this.dispatchChange('bsn', v); }
    },
    email: {
      get () { return this.formObject.email; },
      set (v) { this.dispatchChange('email', v); }
    },
    street: {
      get () { return this.formObject.street; },
      set (v) { this.dispatchChange('street', v); }
    },
    houseNumber: {
      get () { return this.formObject.houseNumber; },
      set (v) { this.dispatchChange('houseNumber', v); }
    },
    houseNumberExtension: {
      get () { return this.formObject.houseNumberExtension; },
      set (v) { this.dispatchChange('houseNumberExtension', v); }
    },
    zipCode: {
      get () { return this.formObject.zipCode; },
      set (v) { this.dispatchChange('zipCode', v); }
    },
    city: {
      get () { return this.formObject.city; },
      set (v) { this.dispatchChange('city', v); }
    },
    country: {
      get () { return this.formObject.country; },
      set (v) { this.dispatchChange('country', v); }
    }

  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

p {
  color: $primary-lighten-1;
  font-weight: 500;
}

.input-container {
  // padding: 10px 15px 15px 15px;
  padding: 3px 0px;
  border-radius: $border-radius;
  //background-color: $gray-lighten-3;

  p {
    font-size: 1em;
    margin-left: 1px;
    margin-bottom: 4px;
  }
}
</style>
